import { createFileRoute } from '@tanstack/react-router';
import { OperationsPage } from '@/features/operations/operations-page';
import { operationsGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/operations/')({
  beforeLoad: operationsGuard,
  component: OperationsIndexRoute,
});

function OperationsIndexRoute() {
  return <OperationsPage />;
}
